import SportBookMatchInner from "./SportBookMatchInner";
import { motion } from "framer-motion";
import { useTabIndicator } from "../../component/useTabIndicator";
import useSportsBookLogic from "../useLogic/useSportbookLogic";
const SportsBook = ({
  data,
  user,
  detail,
  profileData,
  setBetSlipObject,
  favouriteList,
  position,
  BetSlip,
  addToFavioute,setShowInfo
}) => {
  const {
    setHeader,
    selected,
    setSelected,
    active,
    setActive,
    handelChange,
    sportBookCheck,
    updatedData,
    parlyBet,
    parlay,
    betSlipObject,
    showBetDialog,
  } = useSportsBookLogic({
    data,
    user,
    detail,
    profileData,
    setBetSlipObject,
    favouriteList,
    position,
    BetSlip,
    addToFavioute,
  });
  const { containerRef, setActiveIndex, indicatorStyle } = useTabIndicator(0);
  return (
    <div>
      <div
        data-v-251e1ccc
        className="s-flex s-items-center"
        style={{
          "--30716420": `translateX(${indicatorStyle?.x || 10}px)`,
          "--1245c4b0": `${indicatorStyle?.width || 41}px`,
        }}
      >
        <div
          data-v-251e1ccc
          className="s-w-full s-overflow-x-scroll s-h-30px s-relative s-flex s-items-center s-bg-market-tab-bg-active s-pt-px"
        >
          <div data-v-251e1ccc className="s-relative s-inline-block s-mr-2">
            <div
              ref={containerRef}
              data-v-251e1ccc
              className="s-w-full s-flex s-jusrify-center s-px-7px s-h-30px s-cursor-pointer s-text-market-sub-text"
            >
              {premiumCategoryArray?.map((res, index) => {
                return (
                  <div
                    onClick={() => {
                      setHeader(res?.type);
                      setActiveIndex(index);
                    }}
                    data-v-251e1ccc
                    name={res?.name}
                    className="s-text-center s-py-2 s-px-4 s-mx-1 s-text-14px s-font-bold"
                  >
                    {res?.name}
                  </div>
                );
              })}
            </div>
            <motion.div
              data-v-251e1ccc
              className="s-tab-indicator s-absolute s-left-0 s-bottom-1 s-rounded-1.5px s-bg-market-sub-text s-h-3px"
            />
          </div>
        </div>
        <div
          data-v-251e1ccc
          className="s-flex s-items-center s-h-30px s-bg-market-tab-bg-active"
        >
          <div onClick={() => setShowInfo(true)}
            data-v-251e1ccc
            className="s-icon-info-circle s-w-16px s-h-16px s-mx-2 s-text-market-sub-text s-opacity-25 dark:s-opacity-45 s-text-16px"
          />
        </div>
      </div>
      {data?.length > 0 ? (
        <div className="s-p-2 s-rounded-b-5px" style={{padding:"0",paddingTop:"7px"}}>
          <SportBookMatchInner
            updatedData={updatedData}
            parly={parlay}
            betSlipObject={betSlipObject}
            handelChange={handelChange}
            setSelected={setSelected}
            BetSlip={BetSlip}
            position={position}
            showBetDialog={showBetDialog}
            favouriteList={favouriteList}
            selected={selected}
            sportBookCheck={sportBookCheck}
            parlyBet={parlyBet}
            detail={detail}
            active={active}
            setActive={setActive}
            addToFavioute={addToFavioute}
          />

          <div className="s-flex s-gap-3px s-items-center s-justify-end s-text-black-500 s-pb-1px s-pt-5px">
            <span className="s-icon-min-max s-text-14px" />
            <span className="s-text-12px">min</span>
            <mark className="s-font-bold s-bg-transparent s-text-12px s-text-black-500">
              1
            </mark>
          </div>
        </div>
      ) : (
        
          <div class="s-bg-white s-rounded-b-xl dark:s-bg-market-tab-bg-active">
            <div class="s-bg-market-tab-active s-h-3px"></div>
            <div class="s-py-3 s-px-4 s-text-14px dark:s-text-black-500">
              Loading Market…
            </div>
          </div>
  
      )}
    </div>
  );
};

export default SportsBook;

const premiumCategoryArray = [
  { type: "all", name: "All" },
  { type: "Popular", name: "Popular" },
  { type: "Match", name: "Match" },
  { type: "Innings", name: "Innings" },
  { type: "Over", name: "Over" },
  { type: "Batsman", name: "Batsman" },
];
const premiumCategoryArraySoccer = [
  { type: 2, name: "All" },
  { type: 1, name: "Popular" },
  { type: 3, name: "Half" },
  { type: 3, name: "Goals" },
  { type: 5, name: "Fast Markets" },
  { type: 6, name: "Special" },
  { type: 7, name: "Corners" },
  { type: 9, name: "Cards" },
  { type: 8, name: "Player" },
  { type: 2, name: "More" },
];
const premiumCategoryArrayTennis = [
  { type: 2, name: "All" },
  { type: 9, name: "Main" },
  { type: 8, name: "Total" },
  { type: 2, name: "More" },
];
